import { defineStore } from 'pinia';
import { useStoreSsPlayer } from '../softswiss/player';

type tPostregModalsNames = 'signup-before-close' | 'after-signup' | 'deposit-before-close';
interface iPostregModalsOptions {
  isSeparatePage?: boolean;
}

export const useStorePostregModalData = defineStore('postregModalData', {
  state: () => ({
    currentActive: null as null | { name: tPostregModalsNames; options: iPostregModalsOptions },
    isSignupBeforeCloseModalShowed: false,
    isDepositBeforeCloseModalShowed: false,
    isBonusToastShown: false,
    isBonusTimeOut: false,
    isBonusToastMinimized: false,
  }),
  getters: {
    postregBonusEndTime(): number | null {
      const storeSsPlayer = useStoreSsPlayer();
      if (!storeSsPlayer.playerInfo.created_at) {
        return null;
      }
      const createdUtcDate = new Date(
        storeSsPlayer.playerInfo.created_at.split('UTC')[0].trim().replace(' ', 'T')
      );
      const createdLocalDate =
        createdUtcDate.getTime() - createdUtcDate.getTimezoneOffset() * 60 * 1000;
      const validUntilDate = new Date(createdLocalDate + 30 * 60000).getTime();

      if (new Date().getTime() > validUntilDate) {
        return null;
      }
      return validUntilDate;
    },
    isShowDepositBeforeCloseModal(): boolean {
      const storeSsPlayer = useStoreSsPlayer();
      return (
        storeSsPlayer.isWithFbFlowSignup &&
        !this.isBonusTimeOut &&
        !storeSsPlayer.isPlayerInAbuserGroup &&
        !this.isDepositBeforeCloseModalShowed
      );
    },
    isShowSignupBeforeCloseModal(): boolean {
      const storeSsPlayer = useStoreSsPlayer();
      return storeSsPlayer.isFbSignupFlowShown && !this.isSignupBeforeCloseModalShowed;
    },
  },
  actions: {
    setActivePostregModal(name: tPostregModalsNames, options: { isSeparatePage?: boolean } = {}) {
      if (name === 'signup-before-close') {
        this.isSignupBeforeCloseModalShowed = true;
      }
      if (name === 'deposit-before-close') {
        this.isDepositBeforeCloseModalShowed = true;
        localStorage.setItem('isDepositBeforeCloseModalShowed', 'true');
      }
      this.currentActive = { name, options };
    },
    closePostregModal() {
      this.currentActive = null;
    },
    toggleBonusToast(value: boolean) {
      this.isBonusToastShown = value;
    },
    setBonusTimeOut(value: boolean) {
      this.isBonusTimeOut = value;
    },
    setBonusToastMinimized(value: boolean) {
      this.isBonusToastMinimized = value;
    },
    setDepositBeforeCloseModalStatus() {
      this.isDepositBeforeCloseModalShowed = Boolean(
        localStorage.getItem('isDepositBeforeCloseModalShowed')
      );
    },
    resetState() {
      this.isBonusToastShown = false;
      this.currentActive = null;
      this.isSignupBeforeCloseModalShowed = false;
      this.isDepositBeforeCloseModalShowed = false;
      this.isBonusTimeOut = false;
      this.isBonusToastMinimized = false;
      localStorage.removeItem('isDepositBeforeCloseModalShowed');
    },
  },
});
